




























































































import { Component, Prop, Vue } from 'vue-property-decorator'
/* module */
import DateClass from '@/app/module/date'
@Component
export default class WeatherContent extends Vue {
  @Prop() private weatherData!: any
  @Prop() private weatherErrorMsg!: string
  @Prop() private showWeatherErrorFlag!: boolean

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private displayWeatherName (value: number|string) {
    return value !== null && value !== undefined ? value : '不明'
  }

  /* 天気アイコンの判定 */
  private judgmentWeatherIcon (code: any, date: any) {
    let hour!: number
    if (date !== '') {
      const dateTime = new Date(date)
      hour = Number(dateTime.getHours())
    }

    // 19:00以上 or 06:00未満の場合夜用のアイコンを返却
    if ((hour >= 19 || hour < 6) && (code === 10 || code === 20 || code === 21 || code === 24)) {
      switch (code) {
        // 晴れ
        case 10:
          return require('@/assets/icon/weather_forecast/forecast_icon-moon_iphone.png')

        // 晴れときどき曇り
        case 20:
          return require('@/assets/icon/weather_forecast/forecast_icon-moon_cloud_iphone.png')

        // 晴れ時々くもり にわか雨の可能性あり
        case 21:
        case 24:
          return require('@/assets/icon/weather_forecast/forecast_icon-moon_cloud(rain)_iphone.png')
      }
    } else {
      switch (code) {
        // 晴れ
        case 10:
          return require('@/assets/icon/weather_forecast/forecast_icon-sun_iphone.png')

        // 晴れときどき曇り
        case 20:
          return require('@/assets/icon/weather_forecast/forecast_icon-sun_cloud_iphone.png')

        // 晴れ時々くもり にわか雨の可能性あり
        case 21:
        case 24:
          return require('@/assets/icon/weather_forecast/forecast_icon-sun_cloud(rain)_iphone.png')

        // くもり
        case 30:
        case 34:
          return require('@/assets/icon/weather_forecast/forecast_icon-cloud_iphone.png')

        // くもり 雨の可能性あり
        case 31:
          return require('@/assets/icon/weather_forecast/forecast_icon-cloud(rain)_iphone.png')

        // くもり時々雪
        case 33:
          return require('@/assets/icon/weather_forecast/forecast_icon-snow_cloud_iphone.png')

        // くもり時々雨
        case 41:
          return require('@/assets/icon/weather_forecast/forecast_icon-cloud_rain_iphone.png')

        // 雪か雨時々くもり
        case 42:
          return require('@/assets/icon/weather_forecast/forecast_icon-sleet_cloud_iphone.png')

        // 雪時々くもり
        case 43:
          return require('@/assets/icon/weather_forecast/forecast_icon-snow_cloud_iphone.png')

        // 雨
        case 51:
        case 54:
        case 61:
        case 64:
        case 71:
        case 74:
        case 81:
        case 84:
          return require('@/assets/icon/weather_forecast/forecast_icon-rain_iphone.png')

        // みぞれ（雪か雨）
        case 52:
        case 55:
          return require('@/assets/icon/weather_forecast/forecast_icon-sleet_iphone.png')

        // 雪
        case 53:
        case 56:
        case 63:
        case 66:
        case 73:
        case 76:
        case 83:
        case 86:
          return require('@/assets/icon/weather_forecast/forecast_icon-snow_iphone.png')

        // 不明
        default:
          return require('@/assets/icon/weather_unknown.svg')
      }
    }
  }

  private displayDate (date: any) {
    let formingDate: string
    if (date !== '') {
      const dateTime = new Date(date.replace(/-/g, '/'))
      formingDate = DateClass.toDoubleDigits(dateTime.getDate())
    } else {
      formingDate = '-'
    }
    return formingDate
  }

  private displayTime (date: any) {
    let formingTime: string
    if (date !== '') {
      const dateTime = new Date(date.replace(/-/g, '/'))
      formingTime = DateClass.toDoubleDigits(dateTime.getHours()) + ':' + DateClass.toDoubleDigits(dateTime.getMinutes())
    } else {
      formingTime = '-'
    }
    return formingTime
  }
}
